<div class="elementor-element elementor-element-51dc4360 elementor-button-align-stretch elementor-widget elementor-widget-form" data-id="51dc4360" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Next&quot;,&quot;step_previous_label&quot;:&quot;Previous&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
    <h4>
        Please enter OTP that was sent to you via SMS.
    </h4>
    <div class="elementor-widget-container">
        <form class="elementor-form customer-sign-up-form" @submit.prevent="validateForm">
            <div class="elementor-form-fields-wrapper elementor-labels-">
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <label for="form-field-otp" class="elementor-field-label elementor-screen-only">
                        OTP
                    </label>
                    <div class="text-danger">
                        {{otpValidationMessage}}
                    </div>
                    <div class="text-danger" v-if="!otpIsVerified">
                        OTP could not be verified. Please double check the OTP and try again.
                    </div>
                    <input type="text" id="form-field-otp" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="OTP" required="required" aria-required="true" v-model="otp">
                </div>
                <div class="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons">
                    <button type="submit" class="elementor-button elementor-size-sm" :disabled="loading">
                        <span>
                            <span class=" elementor-button-icon">
                            </span>
                            <span class="elementor-button-text">Continue</span>
                        </span>
                    </button>
                </div>
            </div>
        </form>
        <br>
        <br>
        <br>
        <div class="horizontal-center">
            <p>
               {{otpResendMessage}}
            </p>
            <p class="text-success" v-if="showOtpResendSuccessMessage">
                OTP resend successful. Please check your SMS.
            </p>
            <div class="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons">
                <button class="elementor-button elementor-size-sm" :disabled="!canResendOtp" @click="resendOtp">
                    <span>
                        <span class=" elementor-button-icon">
                        </span>
                        <span class="elementor-button-text">Resend OTP</span>
                    </span>
                </button>
            </div>
            <div class="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons">
                <button class="elementor-button elementor-size-sm" :disabled="!canResendOtp" @click="goBackToPreviousStep">
                    <span>
                        <span class=" elementor-button-icon">
                        </span>
                        <span class="elementor-button-text">Restart Sign Up</span>
                    </span>
                </button>
            </div>
        </div>
        
    </div>
</div>
